import Link from "next/link";

import { Anchor } from "@newsela/angelou";

import { NewStudentAssignmentTooltip } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AssignmentsLink/NewStudentAssignmentTooltip/NewStudentAssignmentTooltip";
import {
  assignmentsAnchorCss,
  relativeLiCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ResourceMenus.styles";
import {
  ASSIGNMENTS_MENU_ITEM_STUDENT,
  ASSIGNMENTS_MENU_ITEM_TEACHER,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

const AssignmentsLink = () => {
  const { isStudent } = useGetUserProperties();

  const assignmentsHref = isStudent
    ? ASSIGNMENTS_MENU_ITEM_STUDENT.href
    : ASSIGNMENTS_MENU_ITEM_TEACHER.href;

  return (
    <li css={relativeLiCss}>
      <Link href={assignmentsHref} passHref legacyBehavior>
        <Anchor
          dataProps={{ "data-qa-selector": "global-nav-assignments" }}
          __cssFor={assignmentsAnchorCss}
        >
          Assignments
        </Anchor>
      </Link>

      <NewStudentAssignmentTooltip />
    </li>
  );
};

AssignmentsLink.displayName = "AssignmentsLink";
export { AssignmentsLink };
